import './index.scss'
import Rails from '@rails/ujs'
import { Controller as BaseController } from 'stimulus'
import I18n from '../../../../javascript/i18n/index.js.erb'

export class Controller extends BaseController {
  static targets = [
    'self', 'noteText', 'saveButton', 'cancelButton', 'deleteButton', 'textareaContainer',
    'groupSelectContainer', 'groupSelect'
  ];

  static values = {
    privacyType: String,
    noteableType: String,
    noteableId: String,
    totalCounterId: String
  };

  editId = null;

  add(event) {
    this.resetTextareaErrors()
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass)
    if (this.hasGroupSelectContainerTarget) {
      this.groupSelectContainerTarget.classList.remove('hidden')
    }
    this.noteTextTarget.value = ''
    this.editId = null
  }

  edit(event) {
    this.resetTextareaErrors()
    this.selfTarget.classList.add(event.currentTarget.dataset.editingClass)

    const canDelete = event.currentTarget.getAttribute('data-can-delete')
    const canEdit = event.currentTarget.getAttribute('data-can-edit')

    if (canEdit === 'true') {
      this.noteTextTarget.removeAttribute('disabled')
      this.saveButtonTarget.classList.remove('hidden')
    } else {
      this.noteTextTarget.setAttribute('disabled', 'true')
      this.saveButtonTarget.classList.add('hidden')
    }

    if (canDelete === 'true') {
      this.deleteButtonTarget.classList.remove('hidden')
      this.deleteButtonTarget.classList.add('flex')
    }

    if (this.hasGroupSelectContainerTarget) {
      this.groupSelectContainerTarget.classList.add('hidden')
    }

    this.noteTextTarget.value = event.currentTarget.getAttribute('data-note-text')
    this.editId = event.currentTarget.getAttribute('data-note-id')
  }

  validateNote() {
    let error = ''

    if (this.noteTextTarget.value.length === 0) {
      error = I18n.t('notes.create.edit_empty_error')
    }

    const errorEvent = new CustomEvent('renderError', { detail: error })
    this.textareaContainerTarget.dispatchEvent(errorEvent)
  }

  save() {
    this.saveButtonTarget.disabled = true
    this.cancelButtonTarget.disabled = true
    if (this.hasDeleteButtonTarget === true) {
      this.deleteButtonTarget.disabled = true
    }

    let url = `/entities/${this.noteableTypeValue}/${this.noteableIdValue}/notes`
    if (this.editId) {
      url += `/${this.editId}`
    }

    const params = {
      note_text: this.noteTextTarget.value,
      privacy_type: this.privacyTypeValue,
      total_counter_id: this.totalCounterIdValue,
      element_id: this.selfTarget.id
    }
    if (this.hasGroupSelectTarget) {
      params.group_id = this.groupSelectTarget.value
    }

    Rails.ajax({
      type: this.editId ? 'put' : 'post',
      dataType: 'script',
      url: url,
      data: $.param(params)
    })

    this.editId = null
  }

  delete() {
    this.saveButtonTarget.disabled = true
    this.cancelButtonTarget.disabled = true
    this.deleteButtonTarget.disabled = true

    Rails.ajax({
      type: 'delete',
      dataType: 'script',
      url: `/entities/${this.noteableTypeValue}/${this.noteableIdValue}/notes/${this.editId}`,
      data: $.param({
        privacy_type: this.privacyTypeValue,
        total_counter_id: this.totalCounterIdValue,
        element_id: this.selfTarget.id
      })
    })

    this.editId = null
  }

  cancel(event) {
    this.selfTarget.classList.remove(event.currentTarget.dataset.editingClass)
    this.deleteButtonTarget.classList.remove('flex')
    this.deleteButtonTarget.classList.add('hidden')

    this.editId = null
  }

  resetTextareaErrors() {
    const errorEvent = new CustomEvent('renderError', { detail: '' })
    this.textareaContainerTarget.dispatchEvent(errorEvent)
  }
}
